module.exports = __webpack_public_path__ + "static/media/girl.3c769702.jpg";